module.exports = __webpack_public_path__ + "static/media/logoQA.3d694d68.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/brand/brands/dif/media/logoQA.png
// module id = 871
// module chunks = 0